import { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import { Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const CreateProductivity = (props) => {
  const httpClient = useHttpClient(true);
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm();
  const [CreateModal, setCreateModal] = useState(false);
  const CreateModalToggle = () => resetForm();
  const history = useHistory();
  const [spinner, setSpinner] = useState(false);

  const onSubmit = async (data) => {
    const productionData = {
      name: data['production_name'], subActivity: JSON.parse(data['sub_activity']), unitProduction: JSON.parse(data['unit_production']),
      unitDimension: JSON.parse(data['unit_dimension'])
    };
    try {
      setSpinner(true);
      const response = httpClient.current?.post(`/api/production`, productionData);
      if ((await response).status === 200) {
        setSpinner(false);
        props.productions();
        resetForm();
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const handleCancel = () => {
    resetForm();
  };

  const resetForm = () => {
    resetField('production_name');
    resetField('sub_activity');
    resetField('unit_dimension');
    resetField('unit_production');

    setCreateModal(!CreateModal);
  };

  const [units, setUnits] = useState([]);
  const [activities, setActivities] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [subactivities, setSubactivities] = useState([]);
  const [cachedSubActivities, setCachedSubActivities] = useState([]);

  useEffect(() => {
    const getSubActivities = async () => {
      httpClient.current?.get(`/api/subactivity/all`).then((response) => {
        setSubactivities(response.data);
        setCachedSubActivities(response.data);

        const dataActivities = response.data.map((subActivity) => subActivity.activity);
        const filteredActivities = dataActivities.filter(
          (value, index, self) => index === self.findIndex((t) => t.name === value.name)
        );
        setActivities(filteredActivities);
      });
    };
    const getUnits = async () => {
      httpClient.current?.get(`/api/unit/all`).then((response) => {
        setUnits(response.data);
      });
    };

    getUnits();
    getSubActivities();
  }, [httpClient]);

  const handleSelectActivity = (e) => {
    const activityId = +e.target.value || null;

    if (!activityId) {
      setSelectedActivity(null);
      return;
    }

    const filteredSubActivities = cachedSubActivities.filter(({ activity }) => activity.id === activityId);
    setSelectedActivity(activityId);
    setSubactivities(filteredSubActivities);
  };


  return (
    <>
      <Button outline color="success" onClick={CreateModalToggle}>
        {' '}
        {props.t('create_production')}
      </Button>
      <Modal isOpen={CreateModal} toggle={CreateModalToggle} centered>
        <ModalHeader toggle={CreateModalToggle}>{props.t('create_production')}</ModalHeader>
        <ModalBody>
          <Fragment>
            {subactivities.length <= 0 ? (
              <div className="text-center">
                <Button outline color="danger" onClick={() => history.push('/settings/sub-activity')}>
                  {props.t('msg_enter_sub_activity')}
                </Button>
              </div>
            ) : spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <FormGroup className="form-row">
                  <label htmlFor="production_name">{props.t('production_name')}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="production_name"
                    id="production_name"
                    aria-invalid={errors.production_name ? 'true' : 'false'}
                    placeholder={props.t('enter_production_name')}
                    {...register('production_name', { required: true })}
                  />
                  <span>{errors.production_name && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>

                <FormGroup className="form-row">
                  <label htmlFor={'unit_dimension'}>{props.t('unit_dimension_name')}</label>
                  <select
                    name="unit_dimension"
                    id="unit_dimension"
                    className="form-control"
                    {...register('unit_dimension')}
                  >
                    <option value="">{props.t('select_unit_dimension')}</option>
                    {units.map((unit, index) => (
                      <option id={unit.id} key={index} value={JSON.stringify(unit)}>
                        {unit.value}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <FormGroup className="form-row">
                  <label htmlFor={'unit_production'}>{props.t('unit_production_name')}</label>
                  <select
                    name="unit_production"
                    id="unit_production"
                    className="form-control"
                    {...register('unit_production')}
                  >
                    <option value="">{props.t('select_unit_production')}</option>
                    {units.map((unit, index) => (
                      <option id={unit.id} key={index} value={JSON.stringify(unit)}>
                        {unit.value}
                      </option>
                    ))}
                  </select>
                </FormGroup>



                <FormGroup className="form-row">
                  <label htmlFor={'Activity'}>{props.t('Activity')}</label>
                  <select onChange={handleSelectActivity} name="activity" id="activity" className="form-control">
                    <option value="">{props.t('select_activity')}</option>
                    {activities.map((activity) => (
                      <option key={activity.id} value={activity.id}>
                        {activity.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                {selectedActivity && (
                  <FormGroup className="form-row">
                    <label htmlFor={'sub_activity'}>{props.t('sub_activity_name')}</label>
                    <select
                      name="sub_activity"
                      id="sub_activity"
                      className="form-control"
                      {...register('sub_activity')}
                    >
                      {subactivities.map((subActivity, index) => (
                        <option id={subActivity.id} key={index} value={JSON.stringify(subActivity)}>
                          {subActivity.name}
                        </option>
                      ))}
                    </select>
                  </FormGroup>
                )}

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('save')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={handleCancel}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CreateProductivity);
